<template>
    <div class="user-info text-popper" :style="{ maxWidth: maxWidth }" v-textPopper>
        <span class="small-avatar avatar-border-style-0" :class="'avatar-border-style-' + userInfo.sex || userInfo.creator_sex">
            <img :src="userInfo.avatar || userInfo.creator_avatar" alt="">
        </span>
        <!-- <img :src="userInfo.avatar || userInfo.creator_avatar" alt="" :style="{'width': width + 'px', 'height': height + 'px'}" class="person-img mr5" :class="{'man-border': userInfo.sex === 1, 'woman-border': userInfo.sex === 2}"> -->
        <span :class="{ 'can-click': canClick }" @click="canClick && $router.push(url)">
            {{ userInfo.nickname || userInfo.creator_nickname }}
            <span class="realname" v-if="userInfo.realname">({{ userInfo.realname }})</span>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        userInfo: Object,
        canClick: Boolean,
        url: String,
        maxWidth: {
            type: String,
            default: '100%'
        },
        width: {
            type: Number,
            default: 20
        },
        height: {
            type: Number,
            default: 20
        }
    }
}
</script>

<style lang="scss" scoped>
.user-info {
    display: inline-block;
    font-size: 14px;
    color: #333;
    vertical-align: middle;

    &.text-popper {
        width: auto;
    }

    .can-click {
        color: #3C90FF !important;
        font-weight: normal;
        cursor: pointer;

        .realname {
            color: #3C90FF !important;
        }
    }

    .nickname {
        flex: none;
    }

    .realname {
        color: #999;
    }
}
</style>
